import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordValidator(control: AbstractControl) {
    if (control && (control.value != null || control.value != undefined)) {
        let password = control.value;
        let pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,15})");
        // let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");

        let isStrong = pattern.test(password);
        if (!isStrong) {
            return {
                isNotStrong: true
            };
        }
        return null;
    }
    return null;
}
export function matchPasswordValidator(control: AbstractControl): { invalid: boolean } | null {
    if (control.get('password')?.value !== control.get('confirmpassword')?.value)
        return { invalid: true };
    return null;
}
export function paidValidator(control: AbstractControl): { paidInvalid: boolean } | null {
    if (control) {
        if (control.value && control.value.paid && control.value.nominal) {
            if (control.value && control.value.paid && control.value.issued) {
                let paid: number = parseInt(control.value.paid);
                let issued: number = parseInt(control.value.issued);
                if (issued && paid) {
                    if (paid > issued)
                        return { paidInvalid: true };
                }
            }
            let paid: number = parseInt(control.value.paid);
            let nominal: number = parseInt(control.value.nominal);
            if (nominal && paid) {
                if (paid > nominal)
                    return { paidInvalid: true };
            }
        } else if (control.value && control.value.paid && control.value.issued) {
            let paid: number = parseInt(control.value.paid);
            let issued: number = parseInt(control.value.issued);
            if (issued && paid) {
                if (paid > issued)
                    return { paidInvalid: true };
            }
        }
    }
    return null;
}
export function issuedValidator(control: AbstractControl): { issuedInvalid: boolean } | null {
    if (control) {
        if (control.value && control.value.nominal && control.value.issued) {
            let nominal: number = parseInt(control.value.nominal);
            let issued: number = parseInt(control.value.issued);
            if (issued && nominal) {
                if (issued > nominal)
                    return { issuedInvalid: true };
            }
        }
    }
    return null;
}
export function nominalValidator(control: AbstractControl): { nominalInvalid: boolean } | null {
    if (control) {
        if (control.value && control.value.nominal && control.value.shares) {
            let total: number = parseInt(control.value.shares);
            let nominal: number = parseInt(control.value.nominal);
            if (total && nominal) {
                if (nominal > total)
                    return { nominalInvalid: true };
            }
        }
    }
    return null;
}

export function checkValidEmail(value: any) {
    if (value && (value != null || value != undefined)) {
        let valueRegex = new RegExp('^[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}');
        let regMatches = valueRegex.test(value);
        return { validEmail: regMatches };
    }
    return { validEmail: false };
}

export function checkValidPhoneNumber(value: any) {
    if (value && (value != null || value != undefined)) {
        let valueRegex = new RegExp('^((256[0-9]{9})|(07[0-9]{8}))$');
        let regMatches = valueRegex.test(value);
        return { validPhone: regMatches };
    }
    return { validPhone: false };
}

export function isValidEmailAddress(email: string): boolean {
    if (email) {
        const regExp = new RegExp('^[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')
        return regExp.test(email);
    }
    return false;
}

export function isValidMobileNumber(mobileNumber: string): boolean {
    if (mobileNumber) {
        const regExp = new RegExp('^((256[0-9]{9})|(07[0-9]{8}))$')
        return regExp.test(mobileNumber);
    }
    return false;
}